
import Vue from 'vue'
import { trackEvent } from '@/utils/ga'

Vue.directive('track', {
  bind (el, binding) {
    const { value } = binding
    function track () {
      const { params = {}, eventName = '' } = value
      trackEvent(eventName, params)
    }
    el.trackHandler = track
    el.addEventListener('click', el.trackHandler)
  },
  unbind (el) {
    el.removeEventListener('click', el.trackHandler)
  }
})